import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

export const initialize=(node,setPrevIsDisabled,setNextIsDisabled,view,prevExtentButton,nextExtentButton)=>{

    //view.when(()=>{view.ui.add(node, "top-left")});
    view.ui.add(node, "top-left")
          
            let _prevExtent = false;
            let _preExtent = null;
            let _currentExtent = null;
            let _extentHistory = [];
            let _extentHistoryIndx = 0;
            let _nextExtent = false;

            prevExtentButton.addEventListener("click", () => {
                if (_extentHistory[_extentHistoryIndx].preExtent) {
                    _prevExtent = true;
                    view.goTo(_extentHistory[_extentHistoryIndx].preExtent);
                    _extentHistoryIndx--;
                }
              });
              
            nextExtentButton.addEventListener("click", () => {
                _nextExtent = true;
                if(_extentHistoryIndx< _extentHistory.length-1) {
                  _extentHistoryIndx++;
                  view.goTo(_extentHistory[_extentHistoryIndx].currentExtent);
                }
              });

            //view.when(()=>{
              reactiveUtils.watch(() => [view.stationary, view.extent], 
              ([stationary, extent]) => {
                if (stationary) {
                  let currentExtent = extent as any
                  if(_extentHistory.length<1){
                      extentChangeHandler(extent)
                  }else{
                    if(_extentHistory[_extentHistory.length-1].currentExtent.center.x===currentExtent.center.x){
                      extentHistoryChange()
                    }else{
                      extentChangeHandler(extent)
                    }
                  }
                }
              })
            //})

            function extentChangeHandler(evt) {
              if (_prevExtent || _nextExtent) {
                  _currentExtent = evt;
                } else {
                  _preExtent = _currentExtent;
                  _currentExtent = evt;
                  if(_extentHistory.length>15){
                    _extentHistory.splice(0,5)
                  }
                  _extentHistory.push({
                    preExtent: _preExtent,
                    currentExtent: _currentExtent
                  });
                  _extentHistoryIndx = _extentHistory.length - 1;
                }
              _prevExtent = _nextExtent = false;
              extentHistoryChange();
            }
              
            function extentHistoryChange() {
              if(_extentHistoryIndx >= 1 ){
                setPrevIsDisabled(false);
              } else {
                setPrevIsDisabled(true);
              }
              if(_extentHistory.length >= 0 && _extentHistoryIndx < _extentHistory.length - 1){
                setNextIsDisabled(false);
              } else {
                setNextIsDisabled(true);
              }
            }  

}